import script from "./sport-live-tv-rows.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-rows.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-rows.vue?vue&type=style&index=0&id=3e1cb4fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1cb4fe"]])

export default __exports__